import { ButtonLink, SubsectionTitle } from '@sleepstation/components'
import { HLayout, VLayout } from '@sleepstation/components-layouts'
import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { LAYOUT_ALIGN, LAYOUT_SPACING, SIZE } from '@sleepstation/const'
import {
  backgroundColor,
  borderColor,
  borderRadius,
  padding,
  right,
  top,
} from '@sleepstation/style-api-helpers'
import { defaultBorder } from '@sleepstation/style-mixins'
import { outsetHighlightTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import NOTICE_TYPE from '../../../../../const/noticeType'
import noticeTheme from '../../../../../themes/noticeTheme'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

// TODO: Add border width with rhythm;
const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.MEDIUM,
  'data-cy': `hub-notice`,
})`
  ${padding([[0.75, 0.75, 1]])}
  ${borderRadius(0.5)}
  ${defaultBorder(`all`)}
  ${borderColor(`border`)}
  ${backgroundColor(`backgroundStart`)}
  position: relative;
  border-width: 4px;
`

const Header = styled(HLayout).attrs({
  spacing: LAYOUT_SPACING.MEDIUM,
  align: LAYOUT_ALIGN.CENTER,
  'data-cy': `hub-notice-title`,
})`
  > *:last-child {
    flex-grow: 2;
  }
`

const Body = styled.div`
  font-size: 18px;
  max-width: 640px;
`

const CloseButtonWrapper = styled.div`
  position: absolute;
  ${top(0.5)}
  ${right([0.5])}
  margin: 0;
  padding: 0;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Notice = ({ noticeType, title, bodyAst, onClose }) => {
  const theme =
    noticeType === NOTICE_TYPE.REJECTED ? outsetHighlightTheme : noticeTheme
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <Header>
          <SubsectionTitle>{title}</SubsectionTitle>
        </Header>
        <Body>
          <CopyRenderer htmlAst={bodyAst} isCompact />
        </Body>
        <CloseButtonWrapper>
          <ButtonLink
            data-cy="notice-close-button"
            icon="close"
            size={SIZE.DEFAULT}
            onClick={onClose}
          />
        </CloseButtonWrapper>
      </Layout>
    </ThemeProvider>
  )
}

Notice.propTypes = {
  noticeType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  bodyAst: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default Notice
